/**
 * O CONTROLADOR DOS DADOS — UM LUGAR SÓ (decisão do pesquisador, 25/10/2026).
 *
 * Por ora, o controlador (LGPD) é a pessoa física responsável pelo Portal Simulados. Quando houver CNPJ, troca-se AQUI
 * (`tipo`, `nome` = razão social, `documento` = CNPJ) — e as páginas que o citam (Privacidade, Sobre, Excluir conta) mudam
 * juntas, sem reescrever a política. O texto da política em rascunho (`docs/POLITICA-DE-PRIVACIDADE-rascunho.md`) usa o
 * mesmo bloco, na seção 1.
 *
 * NUNCA aqui: CPF nem endereço residencial. A pessoa física se identifica pelo NOME e pelo CONTATO.
 */
export const CONTROLADOR = {
  tipo: 'pessoa física' as 'pessoa física' | 'pessoa jurídica',
  /** Nome da pessoa física, ou a razão social quando houver CNPJ. */
  nome: 'Fernando Jorge Siqueira Cavalcante',
  /** CNPJ, quando houver. Nulo para pessoa física — o CPF não é publicado. */
  documento: null as string | null,
  /** O canal do titular e do encarregado (LGPD, art. 41). */
  contato: 'contato@portalsimulados.com.br',
} as const;
